import React from "react";
import Modal from "../../component/Inc/Modal";

function PopRegisterParticipant(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input pop_register_participant">
      <h2 className="pop_tit">참석자 등록</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <select className="select">
                <option value="선택">선택</option>
              </select>
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <section className="com_board_search">
            <article className="search">
              <input
                type="search"
                placeholder="검색할 내용을 입력해 주세요."
                className="input xs type_search"
              />
              <button className="com_btn gray ws xs icon_search"></button>
            </article>
          </section>
          <li className="input_field">
            <div className="com_input_wrap ">
              <div className="list">
                <div className="item">
                  <div className="content">
                    <div className="check">
                      <input type="checkbox" id="chk01" className="com_chk" />
                      <label htmlFor="chk01">김길동103</label>
                    </div>
                  </div>
                </div>
                <div className="item highlight">
                  <div className="content">
                    <div className="check">
                      <input type="checkbox" id="chk02" className="com_chk" />
                      <label htmlFor="chk02">김길동103</label>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="content">
                    <div className="check">
                      <input type="checkbox" id="chk03" className="com_chk" />
                      <label htmlFor="chk03">김길동103</label>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="content">
                    <div className="check">
                      <input type="checkbox" id="chk04" className="com_chk" />
                      <label htmlFor="chk04">김길동103</label>
                    </div>
                  </div>
                </div>
                <div className="item">
                  <div className="content">
                    <div className="check">
                      <input type="checkbox" id="chk05" className="com_chk" />
                      <label htmlFor="chk05">김길동103</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopRegisterParticipant;
